/**
 * Created by james on 6/11/14.
 */

"use strict";

// ---------------------------------------------------
// Require Super PseudoClass

var SoaModel = require('bunsen/models/SoaModel');

// ---------------------------------------------------
// Define Module

/**
 * @class Region
 * @extends SoaModel
 */
var Region = module.exports = SoaModel.extend();

// ---------------------------------------------------
// Dependencies

var _ = require('underscore');

// ---------------------------------------------------
// Define Module Instance Properties

_.extend(Region.prototype, /** @lends Region.prototype */{
    /**
     * True if the region code is the 'World' code
     * @returns {boolean}
     */
    isWorldRegion: function () {
        return Region.regionCodeIsWorld(this.get('code'));
    }
});

// ---------------------------------------------------
// Define Module Static Properties

/**
 * @enum {string} regionType
 * The possible types of regions you can have
 */
var regionType =
    /**
     * @lends Region
     * @lends regionType
     */
    {
        /**
         * Static Shipment Quote region type (for regions that are always available to sellers
         * @memberOf Region
         * @type regionType
         */
        TYPE_STATIC: 'SHIPMENT_QUOTE_STATIC',
        /**
         * Local shipment quote region type. For regions based on seller's store geo
         * @memberOf Region
         * @type regionType
         */
        TYPE_LOCAL: 'LOCAL'
    };

_.extend(Region, /** @lends Region */{
    WORLD_REGION_CODE: 'REST_OF_WORLD',
    US_REGION_CODE: 'CONTINENTAL_US',
    regionCodeIsWorld: function (code) {
        return code === Region.WORLD_REGION_CODE;
    }
}, regionType);


//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/logistics/Region.js
// module id = 1623
// module chunks = 63